import type { UIApiConfig, UserAPI } from '@sydle/ui-api';
import { getAPI } from '@sydle/ui-api';
import languages from '../global/languages.js';
import { getConfig } from '@sydle/ui-utils';

export function locationPathIsNotHome(): boolean {
  let value = true;
  for (let i = 0; i < languages.circleLanguages.length; i++) {
    if (
      window.location.pathname === languages.circleLanguages[i].link ||
      window.location.pathname === languages.circleLanguages[i].link.concat('/')
    ) {
      value = false;
      break;
    }
  }
  return value;
}

export function getLanguagePath(): string {
  const configByLanguage = (getConfig<UIApiConfig>('sydle-ui-blog') as any)?.configByLanguage;
  const language = getAPI<UserAPI>('userAPI')?.getCurrentLanguage();
  const languageConfig = configByLanguage?.find((config) => config.language.code === language);
  return languageConfig?.urlPath ? `/${languageConfig?.urlPath}` : '';
}
